import React from 'react';

import { SVGPropsType } from 'src/types';

function CandleChart(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M6.5999 4.19995H2.3999V11.9H6.5999V4.19995Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M4.5 1.09998V4.39998"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path d="M4.5 11.6V14.9" stroke={stroke} strokeWidth="1.2" strokeMiterlimit="10" />
            <path
                d="M13.5999 5.29999H9.3999V10.6H13.5999V5.29999Z"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M11.5 3.09998V5.39998"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path d="M11.5 10.6V12.9" stroke={stroke} strokeWidth="1.2" strokeMiterlimit="10" />
        </svg>
    );
}

export default CandleChart;
